'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  font-size: 0.7rem;\n  text-align: center;\n  max-width: 75%;\n  padding: 1.5rem;\n  a, a:visited, a:active {\n    color: #0275d8\n  }\n'], ['\n  font-size: 0.7rem;\n  text-align: center;\n  max-width: 75%;\n  padding: 1.5rem;\n  a, a:visited, a:active {\n    color: #0275d8\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = require('react-router-dom');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var FinePrint = _styledComponents2.default.div(_templateObject);

/** @class Terms
  * A component for displaying terms and
  * conditions of a virtual expo.
  * @prop {string} name - the name of the vexpo
  * @prop {string} supportEmail - the email address for concerns.
  */

var Terms = function (_Component) {
  _inherits(Terms, _Component);

  function Terms() {
    _classCallCheck(this, Terms);

    return _possibleConstructorReturn(this, (Terms.__proto__ || Object.getPrototypeOf(Terms)).apply(this, arguments));
  }

  _createClass(Terms, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        FinePrint,
        null,
        'The ',
        this.props.name,
        ' does not share login information with any business, show exhibitor, or third party. We do not send you ads. See our ',
        _react2.default.createElement(
          _reactRouterDom.Link,
          { to: '/privacy' },
          ' Privacy Policy '
        ),
        ' and our ',
        _react2.default.createElement(
          _reactRouterDom.Link,
          { to: '/tos' },
          ' Terms of Service '
        ),
        ' for details. Questions can be addressed to ',
        _react2.default.createElement(
          'a',
          { href: 'mailto:' + this.props.supportEmail },
          this.props.supportEmail
        )
      );
    }
  }]);

  return Terms;
}(_react.Component);

exports.default = Terms;


Terms.propTypes = {
  name: _propTypes2.default.string.isRequired,
  supportEmail: _propTypes2.default.string.isRequired
};


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/terms/terms.js
// module id = 261
// module chunks = 0